import { render, staticRenderFns } from "./Ancillaries.vue?vue&type=template&id=e48510c0&scoped=true"
import script from "./Ancillaries.vue?vue&type=script&lang=js"
export * from "./Ancillaries.vue?vue&type=script&lang=js"
import style0 from "./Ancillaries.vue?vue&type=style&index=0&id=e48510c0&prod&lang=scss&scoped=true"
import style1 from "./Ancillaries.vue?vue&type=style&index=1&id=e48510c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48510c0",
  null
  
)

export default component.exports